import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';

if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    console.warn('[preloadError] reloading for new bundle', event);
    window.location.reload();
  });
}

declare const __APP_VERSION__: string;

// Sentry 초기화
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_MOBILE,
  environment: import.meta.env.VITE_ENV || 'development',
  release: `safetyhub-mobile@${__APP_VERSION__}`,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: import.meta.env.VITE_ENV === 'production' ? 0.2 : 1.0,
  enabled: import.meta.env.VITE_ENV === 'production' && !!import.meta.env.VITE_SENTRY_DSN_MOBILE,
});

function SentryFallback() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '2rem', textAlign: 'center' }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>오류가 발생했습니다</h1>
      <p style={{ color: '#666', marginBottom: '1.5rem' }}>예기치 않은 오류가 발생했습니다. 페이지를 새로고침해 주세요.</p>
      <button
        onClick={() => window.location.reload()}
        style={{ padding: '0.75rem 1.5rem', backgroundColor: '#1e40af', color: '#fff', border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '1rem' }}
      >
        새로고침
      </button>
    </div>
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryFallback />}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
